import { IconChevronRight } from '@carnica/graphics';
import { Avatar, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Element = function Element(_ref) {
  var onClick = _ref.onClick,
    src = _ref.src,
    text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper'),
    onClick: onClick,
    "data-t-id": "Carnica-Element"
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: cn('icon'),
    image: src,
    size: "s"
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('text')
  }, /*#__PURE__*/React.createElement(Text, {
    size: 16
  }, text)), /*#__PURE__*/React.createElement(IconChevronRight, {
    color: "tertiary",
    size: "m"
  }));
};